import React from 'react';
import PropTypes from 'prop-types';
import MuiButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Link from '../Link';
import { colors } from '../../../config/colors'

const BorderButton = ({ children, variant, color, loading, asLink, ...props }) => {
  if (asLink) {
    return <MuiButton
      variant={variant === 'text' ? undefined : variant}
      color={color}
      component={Link}
      naked
      style={{ textTransform: 'none' }}
      {...props}
    >
      {children}
    </MuiButton>
  }
  return (
    <MuiButton
      variant={variant === 'text' ? undefined : variant}
      color={color}
      disabled={loading}
      startIcon={loading && <CircularProgress size={20} />}
      style={{ textTransform: 'none', borderBottom: `1px solid ${colors.primary.main}`, borderRadius: '0', paddingBottom: 0 }}
      {...props}
    >
      {children}
    </MuiButton>
  );
}



BorderButton.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.any,
  asLink: PropTypes.bool
};

BorderButton.defaultProps = {
  variant: 'contained',
  loading: false,
  asLink: false,
  color: undefined,
  children: '',
};

export default BorderButton;
